(function () {
  'use strict';

  var INTENT_MAX_AGE = 10 * 60 * 1000;
  var REAUTH_INTENT = 'bd:reauth:intent';
  var REAUTH_RETURN_TO = 'bd:reauth:return_to';
  var REAUTH_CREATED_AT = 'bd:reauth:created_at';
  var CLOSE_INTENT = 'bd:close_app:intent';
  var CLOSE_CREATED_AT = 'bd:close_app:created_at';
  var ROUTE_AFTER_LOGIN_INTENT = 'bd:route_after_login:intent';
  var ROUTE_AFTER_LOGIN_CREATED_AT = 'bd:route_after_login:created_at';
  var DEFAULT_REAUTH_RETURN = '/pages/my-tools';
  var DEFAULT_CLOSE_RETURN = '/pages/online-access';
  var V84_SESSION_PREFIX = 'bizdecks:v84:last_magic_login:';
  var MODAL_FOCUSABLE_SELECTOR = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var allowedPrefixes = [
    '/pages/online-access',
    '/pages/my-tools',
    '/pages/my-library',
    '/pages/library',
    '/pages/model',
    '/pages/model-dashboard',
    '/pages/full-model',
    '/pages/seat-dashboard',
    '/pages/seat-confirmation',
    '/pages/seat-dashboard-confirmation'
  ];

  var publicProtectedNavPaths = [
    '/',
    '/products/mba-tools',
    '/pages/contact',
    '/pages/faq',
    '/policies/privacy-policy',
    '/policies/terms-of-service',
    '/pages/returns',
    '/pages/shipping-pre-order-info',
    '/collections/all'
  ];

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function isVisible(element) {
    return !!(element && (element.offsetWidth || element.offsetHeight || element.getClientRects().length));
  }

  function sessionModalFocusable(modal) {
    return qsa(MODAL_FOCUSABLE_SELECTOR, modal).filter(isVisible);
  }

  function read(key) {
    try { return window.sessionStorage.getItem(key); } catch (error) { return null; }
  }

  function write(key, value) {
    try { window.sessionStorage.setItem(key, value); } catch (error) {}
  }

  function remove(key) {
    try { window.sessionStorage.removeItem(key); } catch (error) {}
  }

  function clearReauthIntent() {
    remove(REAUTH_INTENT);
    remove(REAUTH_RETURN_TO);
    remove(REAUTH_CREATED_AT);
  }

  function clearCloseIntent() {
    remove(CLOSE_INTENT);
    remove(CLOSE_CREATED_AT);
  }

  function clearLegacyRouteMarkers() {
    remove('bd:v81:return_after_login');
    remove('bd:v80:return_after_login');
    remove('bd:v79:return_after_login');
  }

  function clearRouteAfterLoginIntent() {
    remove(ROUTE_AFTER_LOGIN_INTENT);
    remove(ROUTE_AFTER_LOGIN_CREATED_AT);
    clearLegacyRouteMarkers();
  }

  function now() {
    return Date.now();
  }

  function intentExpired(createdAt) {
    var created = parseInt(createdAt || '0', 10) || 0;
    return !created || now() - created > INTENT_MAX_AGE;
  }

  function hasFreshIntent(intentKey, createdKey) {
    return read(intentKey) === 'true' && !intentExpired(read(createdKey));
  }

  function hasFreshRouteAfterLoginIntent() {
    return hasFreshIntent(ROUTE_AFTER_LOGIN_INTENT, ROUTE_AFTER_LOGIN_CREATED_AT);
  }

  function hasFreshCloseIntent() {
    return hasFreshIntent(CLOSE_INTENT, CLOSE_CREATED_AT);
  }

  function hasFreshReauthIntent() {
    return hasFreshIntent(REAUTH_INTENT, REAUTH_CREATED_AT);
  }

  function config() {
    return window.BDAppSessionConfig || {};
  }

  function access() {
    var safe = window.BDAppAccess || {};
    var legacy = window.BIZDECKS_V81_CONTEXT || {};
    var loggedIn = typeof safe.loggedIn === 'boolean' ? safe.loggedIn : !!legacy.isLoggedIn;
    var canSeeMyTools = typeof safe.canSeeMyTools === 'boolean' ? safe.canSeeMyTools : !!legacy.canSeeMyTools;
    var isSeatOwner = typeof safe.isSeatOwner === 'boolean' ? safe.isSeatOwner : !!legacy.isSeatOwner;
    var ownerSelfAssigned = typeof safe.ownerSelfAssigned === 'boolean' ? safe.ownerSelfAssigned : !!legacy.ownerSelfAssigned;
    var ownerDashboardFirst = typeof safe.ownerDashboardFirst === 'boolean' ? safe.ownerDashboardFirst : isSeatOwner && !canSeeMyTools;

    return {
      loggedIn: loggedIn,
      canSeeMyTools: canSeeMyTools,
      isSeatOwner: isSeatOwner,
      ownerSelfAssigned: ownerSelfAssigned,
      ownerDashboardFirst: ownerDashboardFirst
    };
  }

  function isAllowedPath(pathname) {
    return allowedPrefixes.some(function (prefix) {
      return pathname === prefix || pathname.indexOf(prefix + '/') === 0;
    });
  }

  function isProtectedPath() {
    return isAllowedPath(window.location.pathname || '/');
  }

  function safeReturnTo(value, fallback) {
    var target = String(value || '').trim();
    if (!target || target.charAt(0) !== '/' || target.indexOf('//') === 0 || /[\\\r\n]/.test(target) || target.indexOf('://') !== -1) return fallback;

    try {
      var parsed = new URL(target, window.location.origin);
      if (parsed.origin !== window.location.origin) return fallback;
      if (!isAllowedPath(parsed.pathname)) return fallback;
      return parsed.pathname + parsed.search;
    } catch (error) {
      return fallback;
    }
  }

  function currentRelativeUrl() {
    return safeReturnTo(window.location.pathname + window.location.search, DEFAULT_REAUTH_RETURN);
  }

  function logoutUrl() {
    return config().logoutUrl || '/account/logout';
  }

  function refreshSessionTimestamp() {
    try {
      var updated = false;
      for (var index = 0; index < window.localStorage.length; index += 1) {
        var key = window.localStorage.key(index);
        if (key && key.indexOf(V84_SESSION_PREFIX) === 0) {
          window.localStorage.setItem(key, String(now()));
          updated = true;
        }
      }
      if (!updated) window.localStorage.setItem('bd:app-session:last_refresh', String(now()));
    } catch (error) {}
  }

  function buildLoginUrl(target) {
    return '/customer_authentication/login?return_to=' + encodeURIComponent(safeReturnTo(target, DEFAULT_REAUTH_RETURN));
  }

  function startReauth() {
    var target = currentRelativeUrl();
    clearRouteAfterLoginIntent();
    clearCloseIntent();
    write(REAUTH_INTENT, 'true');
    write(REAUTH_RETURN_TO, target);
    write(REAUTH_CREATED_AT, String(now()));
    window.location.assign(logoutUrl());
  }

  function startCloseApp() {
    clearRouteAfterLoginIntent();
    clearReauthIntent();
    write(CLOSE_INTENT, 'true');
    write(CLOSE_CREATED_AT, String(now()));
    window.location.assign(logoutUrl());
  }

  function routeAfterLoginMarkerPresent() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      return params.get('bd_route_after_login') === '1';
    } catch (error) {
      return false;
    }
  }

  function removeRouteAfterLoginMarker() {
    var url;

    if (!routeAfterLoginMarkerPresent()) return;
    if (!window.history || typeof window.history.replaceState !== 'function') return;

    try {
      url = new URL(window.location.href);
      url.searchParams.delete('bd_route_after_login');
      window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
    } catch (error) {}
  }

  function clearOnlineAccessRouteLoading(root) {
    qsa('[data-bd-online-access-root]', root || document).forEach(function (container) {
      container.classList.remove('bd-online-v72--route-loading');
      container.setAttribute('data-bd-route-login-loading', 'false');

      qsa('[data-bd-route-login-loader]', container).forEach(function (loader) {
        loader.hidden = true;
      });

      qsa('[data-bd-route-hidden-content]', container).forEach(function (content) {
        content.hidden = false;
        content.removeAttribute('data-bd-route-hidden-content');
      });
    });
  }

  function startRouteAfterLoginIntent() {
    clearCloseIntent();
    clearReauthIntent();
    clearLegacyRouteMarkers();
    write(ROUTE_AFTER_LOGIN_INTENT, 'true');
    write(ROUTE_AFTER_LOGIN_CREATED_AT, String(now()));
    window.setTimeout(clearLegacyRouteMarkers, 0);
  }

  function routeAfterOnlineAccessLogin() {
    if ((window.location.pathname || '') !== '/pages/online-access') return;
    if (hasFreshCloseIntent()) {
      clearRouteAfterLoginIntent();
      clearCloseIntent();
      removeRouteAfterLoginMarker();
      clearOnlineAccessRouteLoading(document);
      return;
    }

    if (!routeAfterLoginMarkerPresent()) {
      clearRouteAfterLoginIntent();
      clearOnlineAccessRouteLoading(document);
      return;
    }

    var ctx = access();
    if (!ctx.loggedIn || !hasFreshRouteAfterLoginIntent() || hasFreshCloseIntent() || hasFreshReauthIntent()) {
      clearRouteAfterLoginIntent();
      removeRouteAfterLoginMarker();
      clearOnlineAccessRouteLoading(document);
      return;
    }

    clearRouteAfterLoginIntent();
    removeRouteAfterLoginMarker();

    if (ctx.canSeeMyTools) {
      window.location.replace('/pages/my-tools');
      return;
    }

    if (ctx.ownerDashboardFirst) {
      window.location.replace('/pages/seat-dashboard');
      return;
    }

    clearOnlineAccessRouteLoading(document);
  }

  function updateOnlineAccessLoginLinks(root) {
    var loginTarget = '/pages/online-access?bd_route_after_login=1';
    var loginUrl = buildLoginUrl(loginTarget);
    qsa('.bd-online-v72 a[data-bd-v81-login-link], .bd-online-v72 a[href*="/customer_authentication/login"]', root).forEach(function (link) {
      link.setAttribute('href', loginUrl);
      link.addEventListener('click', function () {
        startRouteAfterLoginIntent();
      });
    });
  }

  function normalizeProtectedNavigation(root) {
    if (!isProtectedPath()) return;

    var logoTarget = window.location.pathname === '/pages/online-access' ? '/' : DEFAULT_CLOSE_RETURN;
    qsa('a.header__heading-link', root).forEach(function (link) {
      link.setAttribute('href', logoTarget);
    });

    qsa('.bd-edge-tabs__nav a, .bd-v81-rail-panel a', root).forEach(function (link) {
      var raw = link.getAttribute('href') || '';
      var text = (link.textContent || '').trim().toLowerCase();
      var parsed;

      try {
        parsed = new URL(raw, window.location.origin);
      } catch (error) {
        parsed = null;
      }

      var path = parsed ? parsed.pathname : raw;
      var publicPath = publicProtectedNavPaths.indexOf(path) !== -1 || path.indexOf('/products/') === 0 || path.indexOf('/collections/') === 0;
      var publicLabel = text === 'home' || text === 'shop' || text === 'contact' || text === 'faq' || text === 'policies' || text === 'product page';

      if (publicPath || publicLabel) link.remove();
    });
  }

  function bindCloseButtons(root) {
    qsa('[data-bd-close-my-bizdecks], [data-bd-app-session-close]', root).forEach(function (button) {
      if (button.dataset.bdAppCloseBound === 'true') return;
      button.dataset.bdAppCloseBound = 'true';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        startCloseApp();
      });
    });
  }

  function bindReauthButtons(root) {
    qsa('[data-bd-app-session-reauth]', root).forEach(function (button) {
      if (button.dataset.bdAppReauthBound === 'true') return;
      button.dataset.bdAppReauthBound = 'true';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        startReauth();
      });
    });
  }

  function showSessionModal() {
    if (!isProtectedPath()) return;
    if (!access().loggedIn) return;

    var modal = document.querySelector('[data-bd-app-session-modal]');
    if (!modal) return;

    modal.hidden = false;
    document.body.classList.add('bd-app-session-modal-open');
    bindCloseButtons(modal);
    bindReauthButtons(modal);

    var panel = modal.querySelector('[role="dialog"]');
    var firstSafeAction = modal.querySelector('[data-bd-app-session-reauth]');
    if (firstSafeAction && firstSafeAction.focus) {
      firstSafeAction.focus({ preventScroll: true });
    } else if (panel && panel.focus) {
      panel.focus({ preventScroll: true });
    }
  }

  window.BizDecksV85ShowSoftLoginPrompt = showSessionModal;

  document.addEventListener('keydown', function (event) {
    var modal = document.querySelector('[data-bd-app-session-modal]:not([hidden])');
    var panel;
    var focusable;
    var first;
    var last;
    if (!modal) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      event.stopPropagation();
      return;
    }

    if (event.key !== 'Tab') return;

    panel = modal.querySelector('[role="dialog"]');
    focusable = sessionModalFocusable(modal);
    if (!focusable.length) {
      event.preventDefault();
      if (panel && panel.focus) panel.focus({ preventScroll: true });
      return;
    }

    first = focusable[0];
    last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    } else if (!modal.contains(document.activeElement)) {
      event.preventDefault();
      first.focus();
    }
  }, true);

  document.addEventListener('click', function (event) {
    var modal = document.querySelector('[data-bd-app-session-modal]:not([hidden])');
    if (!modal) return;
    if (event.target === modal) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  function cleanupExpiredIntents() {
    if (intentExpired(read(REAUTH_CREATED_AT))) clearReauthIntent();
    if (intentExpired(read(CLOSE_CREATED_AT))) clearCloseIntent();
    if (intentExpired(read(ROUTE_AFTER_LOGIN_CREATED_AT))) clearRouteAfterLoginIntent();
  }

  function handleCompletedReauth() {
    if (!access().loggedIn || read(REAUTH_INTENT) !== 'true') return;
    refreshSessionTimestamp();
    clearReauthIntent();
  }

  function handleFailedCloseFallback() {
    if (!access().loggedIn || read(CLOSE_INTENT) !== 'true') return;
    clearCloseIntent();
  }

  function init(root) {
    cleanupExpiredIntents();
    handleCompletedReauth();
    handleFailedCloseFallback();
    updateOnlineAccessLoginLinks(root || document);
    routeAfterOnlineAccessLogin();
    normalizeProtectedNavigation(root || document);
    bindCloseButtons(root || document);
    bindReauthButtons(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
